import DescriptionIcon from '@mui/icons-material/Description';
import DownloadIcon from '@mui/icons-material/Download';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { adjustHexColor } from '../../../services/shared';
import MessageActions from '../../MessageActions';
import ParentChatMessage from '../../ParentChatMessage';

export const Document = (props: any) => {
  const { message, topMargin } = props;
  const [isHover, setIsHover] = useState(false);
  const design = useSelector((state: any) => state?.design);

  const getDocumentType = (link: string) => {
    const matches = link.match(/\.([a-zA-Z0-9]+)(\?.*)?$/);
    return matches ? matches[1] : '';
  }

  const downloadFile = (url: string) => {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.setAttribute('target', '_blank');
    a.href = url;
    a.download = url.split('/').pop() as string;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  return (
    <>
      <div className={`ele-document image-container relative inline-block rounded-xl py-2 px-2 max-w-80 bg-primaryBgColor max-w-image ${topMargin} ${message.position === 'right' && 'bg-primaryColor'}`}
        onMouseEnter={() => { setIsHover(true) }} onMouseLeave={() => { setIsHover(false) }}>
        {(message?._parent ?
          <ParentChatMessage
            backgroundColor={message.position === 'right' ? adjustHexColor(design.themeColor, 10) : '#EBEDED'}
            parentMessage={message?._parent} messagePosition={message.position}
          />
          : null
        )}
        {
          (message.medias && message.medias.length)
            ?
            message.medias.map((media: any) => {
              return (
                <div key={media.url + message.mid} className="ele-document-container flex cursor-pointer h-[60px] w-full" onClick={() => downloadFile(media.url)}>
                  <div className="ele-document-image-container w-16 bg-footerSelectedBG flex items-center justify-center flex-col rounded-l-xl">
                    <DescriptionIcon
                      fontSize="medium"
                      id="description-icon"
                      aria-haspopup="true"
                      className={`text-primaryColor ele-document-image-icon`}
                    />
                  </div>

                  <div className="ele-document-text-container flex p-4 items-center justify-between bg-white rounded-r-xl w-48 min-w-48 max-w-60">
                    <span className="ele-document-text-message cursor-pointer">document.{getDocumentType(media.url)}</span>

                    <span className="ele-document-download-container cursor-pointer bg-gray-100 p-1 rounded-full">
                      <DownloadIcon
                        fontSize="medium"
                        id="download-button"
                        aria-haspopup="true"
                        className={`text-primaryColor ele-document-download-btn`}
                      />
                    </span>
                  </div>
                </div>
              )
            })
            :
            null
        }
        <MessageActions message={message} show={isHover} />
      </div>
    </>
  );
}